import { render, staticRenderFns } from "./CardThirdParty.vue?vue&type=template&id=3b2c5de8&scoped=true&"
import script from "./CardThirdParty.vue?vue&type=script&lang=js&"
export * from "./CardThirdParty.vue?vue&type=script&lang=js&"
import style0 from "./CardThirdParty.vue?vue&type=style&index=0&id=3b2c5de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2c5de8",
  null
  
)

export default component.exports